export const activeQuizTypes = [
  'slider',
  'select',
  'multiselect',
  'select_with_input',
  'multi_select',
]
